import "../../styles/all.css";
import "./back.css";
import { useTranslation } from "react-i18next";

function Back() {
  const { t } = useTranslation();

  return (
    <>
      <div className="back" data-aos = "fade-left">
        <div className="continerr">
          <h2>{t("join_us")}</h2>
          <h3>
            {t("description")}
          </h3>
        </div>
      </div>
    </>
  );
}

export default Back;